module.exports = __webpack_public_path__ + "static/img/weekly.ee4643e.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/weekly.gif
// module id = YsGy
// module chunks = 1